import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { gutCourseNames } from '@/utils/utils';

@Component({
    name: 'pull-out-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
    },
})

export default class PullOutCard extends Vue {

    // ---------------------------------------------------------------------------
    // Properties
    @Prop()
    private pullOutData: any;

    @Prop()
    private createdDate: any;

    @Prop()
    private contentData: any;


    // ---------------------------------------------------------------------------
    // Methods

    public gutCourse(courses: any) {
        return gutCourseNames(courses);
    }
}
